import { useTripDesignerConfig } from '../config/TripDesignerConfigProvider';
import type { HotelPriceOverride } from '../config/TripDesignerConfigProvider';

/**
 * `TripDesignerConfig.getHotelPriceOverride(hotel)`, unwrapped from config so
 * a component under `components/` (banned from importing config directly)
 * can read it. DMC's wrapper resolves `hotel.previousBooking`; TO passes
 * nothing and this is always `undefined`.
 */
export function useHotelPriceOverride(
  hotel: any,
): HotelPriceOverride | undefined {
  const { getHotelPriceOverride } = useTripDesignerConfig();
  return getHotelPriceOverride?.(hotel);
}
